import { default as theme } from './index.cof';

export default theme;
